/* eslint-disable react/jsx-pascal-case */
import { message, Button, Col, Form, Row, Space, Typography,ProTableOt } from "./../../../components/ui/ot";
import dayjs from 'dayjs';
import React, { useEffect, useRef, useState } from "react";
import { useLogSelf } from "../controller/LogSelfController";
const setParamsFilter = (obj) => {
    //拿掉值為空或是null 的東西
    return Object.entries(obj).reduce((all, [key, value]) => value === "" ? { ...all } : { ...all, [key]: value }, {})
}
const LogSelf = () => {
    const columns = [
        {
            title: '標題',
            dataIndex: 'title',
            key: 'title',
        },
        {
            title: '內容',
            key: "content",
            dataIndex: 'content',
        },
        {
            title: '發送時間',
            dataIndex: 'date_and_time',
            key: 'date_and_time',
        },
        // {
        //     title: '點擊率',
        //     dataIndex: 'click_num',
        //     key: 'click_num',
        // },

        // {
        //     title: '操作',
        //     valueType: 'option',
        //     key: 'option',
        //     fixed: 'right',
        //     sorter: false,
        //     disabled: true,
        //     render: (text, record, _index) => {
        //         return (
        //             <Space wrap>
        //                 <Button
        //                     type="link"
        //                     style={{
        //                         color: '#2BC17B'
        //                     }}
        //                     onClick={() => {
        //                         handleEditRow(record)
        //                     }}
        //                 >
        //                     修改
        //                 </Button>
        //                 <Popconfirm
        //                     title="刪除客戶"
        //                     description="確定刪除勾選客戶?"
        //                     onConfirm={() => handleDeleteRow(record?.news_id)}
        //                     onCancel={() => { }}
        //                 >
        //                     <Button
        //                         type="link"
        //                         danger>
        //                         刪除
        //                     </Button>
        //                 </Popconfirm>
        //             </Space>
        //         )
        //     }
        // },
    ];
    const [extra_columns, set_extra_columns] = useState([]);
    const actionRef = useRef();
    const [pageSize, setPageSize] = useState(20)
    const [selectedRowKeys, setSelectedRowKeys] = useState([])
    const [selectedRowsInfo, setSelectedRowsInfo] = useState([])
    const rowSelection = {
        //不一定都是對id
        onSelectAll: (selected, selectedRows, changeRows) => {
            let select_temp = [...selectedRowKeys]
            let selectRow = [...selectedRowsInfo]
            if (selected) {
                changeRows.map((value, key) => {
                    select_temp.push(value.news_id)
                    selectRow.push(value)
                })

            }
            else {
                changeRows.map((value, key) => {
                    const index = select_temp.indexOf(value.news_id);
                    select_temp.splice(index, 1);
                    selectRow.splice(index, 1);

                })
            }
            setSelectedRowKeys(select_temp)
            setSelectedRowsInfo(selectRow)
        },
        onSelect: (record, selected, selectedRows, nativeEvent) => {
            let select_temp = [...selectedRowKeys]
            let selectRow = [...selectedRowsInfo]
            if (selected) {
                select_temp.push(record.news_id)
                selectRow.push(record)
            }
            else {
                select_temp = select_temp.filter(key => key !== record.news_id)
                selectRow = selectRow.filter(row => row.news_id !== record.news_id)
            }
            setSelectedRowKeys(pre => select_temp)
            setSelectedRowsInfo(selectRow)

        },
        getCheckboxProps: (record) => ({
            // disabled: record.pass === null,
        }),
    };
    const [modalOpen, setModalOpen] = useState(false)
    const [modalLoading, setModalLoading] = useState(false)

    const [form] = Form.useForm();

    const [axiosMode, setAxiosMode] = useState("get")
    const onCleanSelected = () => {
        setSelectedRowKeys([])
        setSelectedRowsInfo([])
    }
    const handleAddRow = () => {
        setAxiosMode("post")
        setModalOpen(true)
        form.resetFields()
    }
    const handleEditRow = (record) => {
        setAxiosMode("patch")
        setModalOpen(true)
        let news_time = dayjs(record?.news_time, "YYYY-MM-DD HH:mm:ss")
        form.resetFields()
        form.setFieldsValue({
            ...record,
            news_time
        })
    }
    const handleDeleteRow = (id) => {
        let data = []
        if (id) {
            data = [{
                news_id: id
            }]
        }

        else {
            data = selectedRowsInfo.map((val) => {
                return {
                    news_id: val?.news_id
                }
            })
        }
        if (data.length > 0) {
            // deleteNewsData(data)
        }
        else {
            message.info("請選擇項目")
        }
    }

    const onFormFinish = (values) => {
        if (axiosMode === "post") {
            console.log(values)
            // postNewsData([values])
        }
        else if (axiosMode === "patch") {
            // patchNewsData([values])
        }
    }
    const onFinish = ({ axiosMode, status, values }) => {
        if (status === "success") {
            if (axiosMode === "post") {
                message.success("新增成功")
                actionRef.current.reloadAndRest();

            }
            else if (axiosMode === "patch") {
                message.success("修改成功")
                actionRef.current.reloadAndRest();

            }
            else if (axiosMode === "delete") {
                message.success("刪除成功")
                actionRef.current.reloadAndRest();
                setSelectedRowKeys([])
                setSelectedRowsInfo([])

            }
            setModalLoading(false)
            setModalOpen(false)
        }
        else if (status === "error") {
            if (axiosMode === "post") {
                message.error("新增失敗")
                actionRef.current.reloadAndRest();
            }
            else if (axiosMode === "patch") {
                message.error("修改失敗")
                actionRef.current.reloadAndRest();
            }
            else if (axiosMode === "delete") {
                message.error("刪除失敗")
                actionRef.current.reloadAndRest();
            }
            setModalLoading(false)
            setModalOpen(false)
        }
    }
    const onBefore = ({ axiosMode, status, values }) => {
        setModalLoading(true)
    }

    const {
        getLogSelfData,
    } = useLogSelf({
        onFinish,
        onBefore,
    })
    const {
        check,
        setCheck,
        checkAll,
        setOrders,
        custom_filter_key,
    } = useTableColumnsCheck(columns)
    useEffect(() => {
        checkAll()
    }, [])

    return <Row>
        <Col span={24}>
            <Typography.Title level={4}>
                推播訊息通知區
            </Typography.Title>
        </Col>
        <Col span={24}>
            <ProTableOt
                actionRef={actionRef}
                headerTitle={<Space>
                    {/* <Button
                        type='primary'
                        onClick={() => {
                            handleAddRow()
                        }}
                        style={{
                            backgroundColor: "#FFF9C9",
                            color: "#000"
                        }}
                    >
                        + 發佈消息
                    </Button> */}
                </Space>}
                columns={columns}
                check={check}
                setCheck={setCheck}
                rowKey={'news_id'}
                selections={{
                    // onChange: (index_, data_) => set_data(data_)
                }}
                toolBarRender={() => [
                    // <Popconfirm
                    //     title="刪除消息"
                    //     description="確定刪除勾選消息?"
                    //     onConfirm={() => handleDeleteRow()}
                    //     onCancel={() => { }}
                    // >
                    //     <Button
                    //         type='primary'
                    //         style={{
                    //             color: "#000",
                    //             backgroundColor: "#ffedee"
                    //         }}

                    //     >
                    //         刪除消息
                    //     </Button>
                    // </Popconfirm>
                ]}
                extra_columns={extra_columns}
                set_extra_columns={set_extra_columns}
                manage_columns={false}
                request={async (params = {}, sort, filter) => {
                    setAxiosMode("get")
                    let newParams = {
                    };
                    let order = setOrders(sort)
                    newParams = {
                        ...params, //只有這個範例要有，其他請看你的後端要什麼資料
                        ...newParams,
                        order,
                        size: params.pageSize,
                        cur_page: params.current,
                        custom_filter_value: params.keyword ?? "",
                        custom_filter_key: custom_filter_key
                    };
                    newParams = setParamsFilter({
                        ...newParams,
                        news_time: dayjs().format("YYYY-MM-DD HH:mm:ss")
                    });
                    setPageSize(params?.pageSize ?? 20)
                    return getLogSelfData(newParams)
                }}
                pageSize={pageSize}
                // rowSelection={{
                //     type: 'checkbox',
                //     selectedRowKeys: selectedRowKeys,
                //     ...rowSelection,
                // }}
                rowSelection={false}
                tableAlertOptionRender={() => {
                    return (
                        <Space size={16}>
                            {/* <Typography.Link>匯出資料</Typography.Link> */}
                        </Space>
                    )
                }}
                tableAlertRender={({
                    selectedRowKeys,
                    selectedRows,
                    // onCleanSelected,
                }) => {
                    return (
                        <Space size={24}>
                            <span>
                                已選擇 {selectedRowKeys.length} 項
                                <a style={{ marginInlineStart: 8 }} onClick={onCleanSelected}>
                                    取消選擇
                                </a>
                            </span>
                        </Space>
                    );
                }}
                scroll={{
                    // x: "max-content"
                }}

            />
        </Col>
    </Row>
}


const useTableColumnsCheck = (columns) => {
    const [check, setCheck] = useState([])
    const checkAll = () => {
        setCheck((pre) => {
            return columns
                .filter((element) => !element.disabled)
                .map((val) => val.key);
        });
    }
    const setOrders = (sorter) => {
        if (sorter) {
            let newOrders = Object.keys(sorter).map((key, index) => {
                if (sorter[key] === "descend") {
                    return JSON.stringify({
                        column: key,
                        type: 'DESC'
                    })
                }
                else {
                    return JSON.stringify({
                        column: key,
                        type: 'ASC'
                    })
                }

            })
            return newOrders
        }
        else {
            return []
        }
    }
    return {
        check,
        custom_filter_key: check,
        setCheck,
        checkAll,
        setOrders
    }
}
export default LogSelf;
